import React, { useState, useEffect, useCallback } from "react";
import {
  AlertTriangle, Shield, Camera, CheckCircle, MapPin, MessageCircle
} from "lucide-react";

const STORY_FRAMES = [
  { icon: AlertTriangle, color: '#EA4335', title: 'Profilo sospeso?', sub: 'Google ha bloccato la tua scheda senza preavviso' },
  { icon: Shield, color: '#EA4335', title: 'Scheda bloccata?', sub: 'Modifiche rifiutate, verifiche infinite, nessuna risposta' },
  { icon: Camera, color: '#FBBC04', title: 'Nessun Virtual Tour?', sub: 'I clienti cercano foto 360° e non le trovano' },
  { icon: CheckCircle, color: '#4285F4', title: 'Ci penso io.', sub: 'Sono Riccardo Rossi, consulente Google certificato' },
  { icon: Shield, color: '#4285F4', title: 'Assistenza completa', sub: 'Sospensioni, recensioni, verifiche — risolvo tutto' },
  { icon: MapPin, color: '#34A853', title: 'Recupero scheda', sub: "La tua attivita' torna visibile su Google Maps" },
  { icon: Camera, color: '#34A853', title: 'Virtual Tour 360°', sub: 'Fotografie immersive che fanno entrare i clienti prima di entrare' },
  { icon: MessageCircle, color: '#FBBC04', title: 'Contattami', sub: 'WhatsApp, telefono o email. Rispondo io, non un bot.' },
];

const AnimatedShort = ({ compact = false }) => {
  const [frame, setFrame] = useState(0);
  const advance = useCallback(() => setFrame(f => (f + 1) % STORY_FRAMES.length), []);

  useEffect(() => {
    const id = setInterval(advance, 2500);
    return () => clearInterval(id);
  }, [advance]);

  const f = STORY_FRAMES[frame];
  const Icon = f.icon;

  return (
    <div
      className={`relative bg-black/40 border border-white/10 rounded-2xl overflow-hidden cursor-pointer select-none ${compact ? 'p-5' : 'p-8 md:p-10'}`}
      style={{ minHeight: compact ? '140px' : '200px' }}
      onClick={advance}
      data-testid="animated-short"
    >
      <div className="flex flex-col items-center text-center transition-all duration-500" key={frame} style={{ animation: 'fadeSlide 0.5s ease-out' }}>
        <div
          className={`${compact ? 'w-10 h-10 rounded-xl mb-2' : 'w-16 h-16 rounded-2xl mb-4'} flex items-center justify-center`}
          style={{ background: `${f.color}15`, border: `1px solid ${f.color}30` }}
        >
          <Icon className={compact ? 'w-5 h-5' : 'w-8 h-8'} style={{ color: f.color }} />
        </div>
        <h3
          className={`${compact ? 'text-lg' : 'text-2xl md:text-3xl'} font-black text-white mb-1`}
          style={{ fontFamily: "'Poppins',sans-serif" }}
        >
          {f.title}
        </h3>
        <p className={`text-gray-400 ${compact ? 'text-xs' : 'text-base'} max-w-md`}>{f.sub}</p>
      </div>
      {/* Progress dots */}
      <div className={`flex justify-center gap-1.5 ${compact ? 'mt-3' : 'mt-6'}`}>
        {STORY_FRAMES.map((_, i) => (
          <button
            key={i}
            onClick={(e) => { e.stopPropagation(); setFrame(i); }}
            className={`h-1.5 rounded-full transition-all ${i === frame ? 'bg-white w-4' : 'bg-white/20 hover:bg-white/40 w-1.5'}`}
          />
        ))}
      </div>
      <div className="absolute top-3 right-3 text-white/20 text-[10px] font-mono">{frame + 1}/{STORY_FRAMES.length}</div>
      <style>{`
        @keyframes fadeSlide { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
};

export default AnimatedShort;
export { STORY_FRAMES };
